<template>
  <b-row>
    <b-col
      cols="12"
      md="6"
    >
      <b-form-group
        :label="$t('accounting_transactions_fee')"
        label-for="transaction_fee"
      >
        <b-form-input
          id="transaction_fee"
          :value="fee"
          type="number"
          min="0"
          step="0.01"
          @input="onFee"
        />
        <small
          v-if="effect.feeExceedsAmount"
          class="text-danger"
        >
          {{ $t('accounting_transactions_fee_exceeds') }}
        </small>
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      md="6"
    >
      <b-form-group
        :label="$t('accounting_transactions_invoice')"
        label-for="transaction_invoice"
      >
        <b-form-file
          id="transaction_invoice"
          :placeholder="$t('accounting_transactions_invoice')"
          accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
          @change="onFile"
        />
        <small
          v-if="fileError"
          class="text-danger d-block"
        >
          {{ $t('accounting_transactions_invoice_invalid') }}
        </small>
        <small
          v-else-if="file"
          class="text-muted d-block"
        >
          {{ file.name }}
        </small>
      </b-form-group>
    </b-col>
    <b-col
      v-if="showEffect"
      cols="12"
    >
      <b-alert
        show
        :variant="effect.feeExceedsAmount ? 'danger' : (effect.negative ? 'warning' : 'light')"
        class="mb-0"
      >
        <div>{{ effectSentence }}</div>
        <div v-if="effect.nextBalance != null">
          {{ $t('accounting_transactions_balance_after', { balance: money(effect.nextBalance) }) }}
        </div>
        <div
          v-if="direction === 'expense' && effect.fee > 0"
          class="small text-muted"
        >
          {{ $t('accounting_transactions_fee_account') }}
        </div>
      </b-alert>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BFormFile, BAlert,
} from 'bootstrap-vue'
import { formatLedgerMoney } from '@/utils/ledger'
import { invoiceFileError, moneyEffect, normalizeFee } from '@/utils/transactionMoney'

export default {
  name: 'TransactionMoneyFields',
  components: {
    BRow, BCol, BFormGroup, BFormInput, BFormFile, BAlert,
  },
  props: {
    direction: {
      type: String,
      default: 'expense',
    },
    amount: {
      type: [Number, String],
      default: null,
    },
    fee: {
      type: [Number, String],
      default: 0,
    },
    file: {
      default: null,
      validator: value => value == null || (typeof File !== 'undefined' && value instanceof File),
    },
    balance: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      fileError: false,
    }
  },
  computed: {
    effect() {
      return moneyEffect({
        direction: this.direction,
        amount: this.amount,
        fee: this.fee,
        balance: this.balance,
      })
    },
    showEffect() {
      return Number(this.amount) > 0 || normalizeFee(this.fee) > 0
    },
    effectSentence() {
      const total = this.money(this.effect.moved)
      if (this.direction === 'income') {
        return this.$t('accounting_transactions_fee_income', { total })
      }
      return this.$t('accounting_transactions_fee_expense', { total })
    },
  },
  methods: {
    money(value) {
      return formatLedgerMoney(value || 0, this.$i18n.locale)
    },
    onFee(value) {
      const next = value === '' || value == null ? 0 : Number(value)
      const fee = Number.isFinite(next) ? next : 0
      this.$emit('update:fee', fee < 0 ? 0 : fee)
    },
    onFile(event) {
      const selected = event?.target?.files ? event.target.files[0] : null
      if (!selected) {
        this.fileError = false
        this.$emit('update:file', null)
        return
      }
      if (invoiceFileError(selected)) {
        this.fileError = true
        this.$emit('update:file', null)
        if (event.target) event.target.value = ''
        return
      }
      this.fileError = false
      this.$emit('update:file', selected)
    },
  },
}
</script>
